var jQuery = require('jquery');
require('jquery.easing');

window.jQuery = jQuery;
window.$ = jQuery;

// var Popper = require('popper.js');
// window.Popper = Popper;
require('moment');
require('bootstrap');
// require('bootstrap/js/dist/alert');
// require('bootstrap/js/dist/button');
// require('bootstrap/js/dist/util');
// require('bootstrap/js/dist/carousel');
// require('bootstrap/js/dist/collapse');
// require('bootstrap/js/dist/dropdown');
// require('bootstrap/js/dist/modal');
// require('bootstrap/js/dist/popover');
// require('bootstrap/js/dist/scrollspy');
// require('bootstrap/js/dist/tab');
// require('bootstrap/js/dist/tooltip');

require('bootstrap-select');
require('pc-bootstrap4-datetimepicker');
// require('bootstrap-datepicker');
// require('bootstrap-material-design');

require('jquery.placeholder');
require('jquery-sticky');
// require('jquery-match-height');

require('owl.carousel');
// require('magnific-popup');
require('jquery-match-height');
// require('lazysizes');
// require('picturefill');

var cookie = require('js-cookie');
require('webticker/jquery.webticker.js');

require('jquery-ias');
require('jquery-ias/src/callbacks.js');
require('jquery-ias/src/extension/paging');
require('jquery-ias/src/extension/spinner');
require('jquery-ias/src/extension/trigger');
require('jquery-ias/src/extension/history');
require('jquery-ias/src/extension/noneleft');

require('@fortawesome/fontawesome-free');


// var elements = document.querySelectorAll('input,select,textarea');

// for (var i = elements.length; i--;) {
//     elements[i].addEventListener('invalid', function () {
//         this.scrollIntoView(false);
//     });
// }

// DOM Ready functions using custom async function so it only funs when jQuery has been fully loaded

$(function() {

    // HTML5 validation scroll offset fixed header
    var delay = 0;
    var offset = 150;

    document.addEventListener('invalid', function(e){
       $(e.target).addClass("invalid");
       $('html, body').animate({scrollTop: $($(".invalid")[0]).offset().top - offset }, delay);
    }, true);
    document.addEventListener('change', function(e){
       $(e.target).removeClass("invalid")
    }, true);

    if (!window._preventBMD) {
        // $('body').bootstrapMaterialDesign();
    }
    // $('.nav-link').button('dispose')
    // Initialise the Ajax funxctions - put most of your js calls in this function
    // or if you need to reload them after an ajax call
    initAjaxJS();

    // $(window).load(function() {
    // });

    if ($('#cookieAcceptBar').length) {
        // var tickerSpeed = $("#webTicker").attr("data-speed");

        $('#webTicker').webTicker({
            speed:100,
            startEmpty:false,
            duplicate:true,
        });

        $('.btn-open').on('click', function() {
            $(this).prev('.content' ).slideToggle( 'slow' );
            $(this).find('.btn-more-icon' ).toggleClass( 'd-none' );
        });
    };

    // Universal Analytics event tracking
    if (typeof ga !== 'undefined') {

        // track all phone number click events
        $('a[href^="tel:"]').on('click', function(e) {
            var href = $(this).attr('href');
            var value = href.split(':');

            // console.log('clicked', $(this).text(), value[1]);
            ga('send', 'event', 'Phone', 'click', value[1]);
        });

        // track all email click events
        $('a[href^="mailto:"]').on('click', function(e) {

            var href = $(this).attr('href');
            var value = href.split(':');

            // console.log('clicked', $(this).text(), value[1]);
            ga('send', 'event', 'Email', 'click', value[1]);
        });

    }

    $(".testimonial-carousel").owlCarousel({
        items:1,
        // nav:true
    });

    // bootstrap carousel
    // $('#carousel-testimonials').carousel();
    if($('#carousel-testimonials').length > 0){
        carouselNormalization('#carousel-testimonials');
    }


    // Scroll to top
    $('#top').on('click', function(e) {
        e.preventDefault();
        $("html, body").animate({ scrollTop: 0 }, 1000);
      return true;
    });


    $('.selectpicker').selectpicker();

    // Search Filters Datepicker
    // Using font-awesome 5 icons
    $.extend(true, $.fn.datetimepicker.defaults, {
        icons: {
            time: 'far fa-clock',
            date: 'far fa-calendar',
            up: 'fas fa-arrow-up',
            down: 'fas fa-arrow-down',
            previous: 'fas fa-chevron-left',
            next: 'fas fa-chevron-right',
            today: 'far fa-calendar-check',
            clear: 'far fa-calendar-times',
            close: 'far fa-times-circle'
        }
    });
    // $('.datepicker').datetimepicker({
    //     format: 'DD/MM/YYYY',
    //     showTodayButton: true,
    //     showClear: true
    // });



    // placeholder polyfill for browsers that need it
    // $('input, textarea').placeholder();


    // Off canvas mobile nav
    $('[data-toggle="offcanvas"]').click(function() {
        $('.offcanvas').toggleClass('active');
        $(this).toggleClass('close-btn')

    });

    $('select[data-toggle="tabOption"]').on('change', function (e) {
        e.preventDefault();
        let target = e.target.value;
        target = $('#' + target);
        target.addClass('active');
        target.siblings().removeClass('active');
    })

    // $("#mob-links.mob-header-links").sticky({topSpacing:0});
    // $("#main-nav.navbar").sticky({topSpacing:0});
    // $("#sticky-wrapper").sticky({topSpacing:54});

    // $('.scrollup').on('click', function() {
    //     $("html, body").animate({
    //         scrollTop: 0
    //     }, 600);
    //     return false;
    // });

    // if ($('.form-enquiry').length) {
    //     $('.product-enquiry-wrap').show();
    // }

    // if ($('.down-scroll').length) {
    //     // Page scroll
    //     $('.down-scroll').bind('click', function(event) {
    //         var $anchor = $(this);

    //         $('html, body').stop().animate({
    //             scrollTop: $($anchor.attr('href')).offset().top - 104
    //         }, 500, 'easeInOutExpo');

    //         event.preventDefault();
    //     });
    // }


    scrollToFormError();

    $(window).on('scroll', function () {
        if ($(this).scrollTop() >= 96) {
            $('#main-nav').addClass('page-down');
            // $('.breadcrumb').css('margin-top', 56 );
        } else {
            // $('.breadcrumb').css('margin-top', 0 );
            $('#main-nav').removeClass('page-down');
        }
    });





    // Mask emails from spammers
    // $('.mask-email').each(function() {
    //     var $email = $(this);
    //     var css = $email.attr('class');
    //     // var label = $email.attr('title');
    //     var address = $email.text().replace(/\s*\[at\]\s*/, '@').replace(/\s*\[dot\]\s*/g, '.');
    //     var query = $email.data('query'); // get query string parameters if present
    //     var params = "";
    //     if (query != null) {
    //         params = query;
    //     }
    //     $email.html('<a href="mailto:' + address + params + '" class="' + css + '">' + address + '</a>');
    //     // clear em out
    //     $email.attr('class', '');
    //     $email.attr('data-query', '');
    // });

    //tabbed url
    if (location.hash.substr(0, 2) == "#!") {
        $('[data-toggle="tab"][href="#' + location.hash.substr(2) + '"]').tab('show');
    }

    $("a[data-toggle='tab']").on("shown.bs.tab", function(e) {
        var hash = $(e.target).attr("href");
        if (hash.substr(0, 1) == "#") {
            location.replace("#!" + hash.substr(1));
        }
    });

    if ($('.tab-pane a').length) {
        $('.tab-pane a').on('click',function (e) {
            var $a = $(this);
            var href = $a.attr('href');

            if (href.slice(0, 1) != '#') {
                return;
            }

            e.preventDefault();
            var tabId = href.slice(1);
            $('[data-toggle="tab"][href="' + href + '"]').tab('show');
            $("html, body").animate({ scrollTop: $('#product-content').offset().top - 150 }, 500);
        });
    }
});

function carouselNormalization(carouselId) {

    window.heights = [], //create empty array to store height values
    window.tallest; //create variable to make note of the tallest slide
    // console.log(carouselId);
    function normalizeHeights(carouselid) {
        jQuery(carouselid+' .carousel-inner .carousel-item').each(function() { //add heights to array
            window.heights.push(jQuery(this).outerHeight());
        });
        window.tallest = Math.max.apply(null, window.heights); //cache largest value
        // console.log(window.tallest);
        jQuery(carouselid+' .carousel-inner .carousel-item').each(function() {
            jQuery(this).css('min-height',window.tallest + 'px');
        });
    }
    normalizeHeights(carouselId);

    jQuery(window).on('resize orientationchange', function () {

        window.tallest = 0, window.heights.length = 0; //reset vars
        jQuery(carouselId+' .carousel-inner .carousel-item').each(function() {
            jQuery(this).css('min-height','0'); //reset min-height
        });

        normalizeHeights(carouselId); //run it again

    });

}

// scroll window to form error element and offset fixed header height
function scrollToFormError() {
    // console.log('scrollToFormError', window.location.hash);
    var windowWidth = $(window).width();
    var formStr = '#form-';
    // enquiry form error anchor offset
    if (window.location.hash && window.location.hash.indexOf(formStr) != -1) {

        var formEl = window.location.hash;
        if ($(formEl).length > 0) {

            // var offsetSize = $('.headerfixed').height();
            // console.log(window.location.hash+' '+offsetSize +' '+$(formEl).scrollTop());

            var offsetSize = $('#main-nav').height() + 50;
            if (windowWidth > 767) {
                // offset
                // animate scrollto
                $('html, body').animate({ scrollTop: $(formEl).offset().top - offsetSize }, 1000);
            } else {
                $('html, body').animate({ scrollTop: $(formEl).offset().top - offsetSize }, 1000);
            }

        }
    }
}

//-----------------------------------------------
// Global AJAX / Application Functions
//-----------------------------------------------
function initAjaxJS() {

    cookiesPolicyBar();

    // Infinite Ajax Scroll
    /* var ias = jQuery.ias({
        container:  '#lazyload-items',
        item:       '.lazyload-item',
        delay:      1000
    });

    ias.extension(new IASSpinnerExtension({
        html: '<p class="text-center"><img src="/img/site/icons/back-gr-d.svg" alt="" /></p>'
    }));

    // Triggered after new items have rendered.
    ias.on('rendered', function(items) {
        var $items = $(items);

        // update match height js
        if($('.mh-item').length > 0){
            // remove the old group
            $('.mh-item').matchHeight({ remove: true });

            // apply matchHeight on the new selection, which includes the new element
            // $('.mh-item').matchHeight();
            // $.fn.matchHeight._update();
            $.fn.matchHeight._apply($('.mh-item'));
        }

    }); */
}


// Accept cookies
function cookiesPolicyBar() {
    // Check cookie
    if (cookie.get('NOVA_Announcement') != "active") {
        $('#cookieAcceptBar').show();

        $(window).on('scroll', function() {
            var scroll = $(window).scrollTop();

            if (scroll >= 40) { /* scroll top menu out of view */
                $('.mm-panels').css('margin-top', 0);

            } else {
                $('.mm-panels').css('margin-top', 40);
            }
        });

    }else{
        $('.mm-panels').css('margin-top', 0);

    }

    //Assign cookie on click
    $('.cookieAcceptBarConfirm').on('click', function() {
        cookie.set('NOVA_Announcement', 'active', { expires: 1 }); // cookie will expire in one day
        $('#cookieAcceptBar').slideToggle( "fast" );
        $('.mm-panels').css('margin-top', 0);

        $(window).on('scroll', function() {
            var scroll = $(window).scrollTop();

            $('.mm-panels').css('margin-top', 0);

        });

    });
}



// WEBPACK FOOTER //
// ./resources/assets/site/js/init.js